import "./wizard.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";
import {getUrlPath, preserveMarketingParams, useLocation} from "@khan/urls";

type Props = {
    underAgeGate: boolean;
};

export default function NoBirthdate(props: Props): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "KhanLabsNoBirthdatePageViewed",
            eventSchemaVersion: 2,
            underAgeGate: props.underAgeGate,
        });
    });

    const location = useLocation();

    const settingsURL = preserveMarketingParams(
        getUrlPath("account", "/khanmigo/checkout"),
        new URLSearchParams(location.search),
    );

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="recoverable-path-heading">
                    {t`Uh oh! You don’t have a birthday set on your account.`}
                </h1>
                <p>
                    <Trans>
                        If you want to use Khanmigo, please{" "}
                        <Link href={settingsURL}>
                            go to your account settings
                        </Link>{" "}
                        and add your birthday.
                    </Trans>
                </p>
                <p>
                    {t`As a reminder, to participate you'll need to be age 18 or older and live in the United States. If you are under 18 and want to test Khanmigo, your parent or guardian needs to sign up.`}
                </p>
            </div>
        </div>
    );
}
